import { OnboardingToolbar } from './OnboardingToolbar';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { ONBOARDING_STEP_REFERRER, OnboardingStepAnswer } from '../types';
import { useOnboardingWizardStepAnalyticsPage } from '../hooks/useOnboardingWizardStepAnalyticsPage';

export const ReferrerStep = (props: {
  stepIndex: number;
  totalSteps: number;
  onNext: (answers: OnboardingStepAnswer[]) => void;
  onSkip: () => void;
}) => {
  useOnboardingWizardStepAnalyticsPage(ONBOARDING_STEP_REFERRER);
  const { stepIndex, totalSteps, onNext, onSkip } = props;
  const [referrer, setReferrer] = useState('');
  const onNextHandler = () => onNext([{ name: 'referrer', value: referrer }]);
  return (
    <div className="onboarding-step__container">
      <Form.Group className="onboarding-step__row">
        <label>How did you learn about Growegy?</label>
        <input
          autoFocus={true}
          value={referrer}
          data-test="onboarding-referrer__input"
          onChange={(
            e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
          ) => setReferrer(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onNextHandler();
            }
          }}
          className="growegy-form__input flex-grow-1"
        />
      </Form.Group>
      <OnboardingToolbar
        stepIndex={stepIndex}
        totalSteps={totalSteps}
        nextDisabled={referrer.trim().length === 0}
        onNext={onNextHandler}
        onSkip={onSkip}
      />
    </div>
  );
};
